export enum DocumentTypeTapEnum {
  LABOR_CERTIFICATION = "0030",
  PAYROLLCHECK = "0033",
}
